import {
  CONTACT_META_TITLE, CONTACT_META_DESCRIPTION, PATH_FAQ, SUPPORT_EMAIL
} from 'constants';
import { ChatWootConsumer } from 'contexts/ChatWootProvider';
import Box from '@mui/material/Box';
import classNames from 'classnames';
import DefaultLayout from 'layouts/DefaultLayout';
import Grid from '@mui/material/Grid';
import Image from 'components/Image';
import Link from 'next/link';
import MuiLink from '@mui/material/Link';
import PageContent from 'components/Onboard/PageContent';
import PageHead from 'components/Head/PageHead';
import React from 'react';
import styles from 'styles/jss/pages/legalStyle';
import makeClasses from 'hooks/useClasses';
import Typography from '@mui/material/Typography';

const Contact = () => {
  const classes = makeClasses(styles);
  const { showChat } = ChatWootConsumer();

  return (
    <PageContent
      title="Contact Us"
      loading={false}
    >
      <PageHead
        title={CONTACT_META_TITLE}
        description={CONTACT_META_DESCRIPTION}
      />
      <Grid
        container
        justifyContent="center"
        spacing={10}
      >
        <Grid
          item
          xs={12}
          sm={6}
          className={classNames(classes.legal, 'privacy')}
          sx={{
            justifyContent: { xs: 'center', sm: 'right' },
            alignContent: { xs: 'center', sm: 'right' },
            display: 'flex'
          }}
        >
          <Box position="relative" width={300} height={300} sx={{ display: 'flex' }}>
            <Image
              src="/img/marketing/landing/promo/book_85x85.png"
              alt="8.5x11 Book"
              layout="fill"
              objectFit="cover"
            />
          </Box>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          p={5}
          textAlign="left"
          alignContent="left"
          className={classNames(classes.legal, 'privacy')}
        >
          <Typography variant="bookPreview" component="h1" mt={0}>
            Have Questions?
          </Typography>
          <Typography>
            Find answers to your book creation, shipping, or ordering questions in our
            {' '}
            <Link href={PATH_FAQ} passHref>
              <MuiLink color="primary" underline="hover" component="a" target="_blank">
                FAQ.
              </MuiLink>
            </Link>
          </Typography>

          <Typography variant="bookPreview" component="h1" mt={5}>
            Still Need Help?
          </Typography>
          <Typography>
            <strong>Fastest: </strong>
            <MuiLink color="primary" underline="hover" component="a" onClick={showChat}>
              Chat with us
            </MuiLink>
            <br />
            <strong>Email: </strong>
            <Link href={`mailto:${SUPPORT_EMAIL}`} passHref>
              <MuiLink color="primary" underline="hover" component="a" target="_blank">
                {SUPPORT_EMAIL}
              </MuiLink>
            </Link>
            {/* <br />
            <strong>Phone: </strong>
            {SUPPORT_PHONE} */}
          </Typography>
        </Grid>
      </Grid>
    </PageContent>
  );
};

Contact.getLayout = (page) => (
  <DefaultLayout>{page}</DefaultLayout>
);
export default Contact;
